// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__aptoB","boxTitle":"Qualiphy_boxTitle__qG-4V","box":"Qualiphy_box__1D0rs","toggleWrap":"Qualiphy_toggleWrap__2xO4-"};